// Language translations for Perkins Fuel Calculator
export const translations = {
    en: {
        // Main form section
        'tell-us-about-engine': 'Tell us about your engine',
        'choose-engine-model': 'Choose Engine Model',
        'engine-running-hours': 'Engine Running Hours p/a',
        'calculate': 'Calculate',
        'calculating': 'Calculating',
        'recalculate': 'Recalculate',
        'connect-with-us': 'Connect with us',
        'distributor-locator': 'Distributor Locator',
        'calculator-assumptions': '*Calculator Assumptions',
        'keep-in-touch': 'Keep in touch',
        'terms-and-conditions': 'Terms and conditions',
        // Form Fields
        'about-you': 'About You',
        'first-name': 'First Name*',
        'surname': 'Surname*',
        'email': 'Email*',
        'select-country': 'Select your Country*',
        'marketing-consent': '* Yes, I would like to receive future marketing communications (such as email) from Perkins, its affiliates and subsidiaries worldwide and the Perkins distributor network. Regardless of whether you decide to receive these marketing communications, Perkins will continue to send service/transactional messages, including those that have to do with any accounts that you may have with us.',
        'submit': 'Submit',
        'distributor-contact': 'Speak to your local distributor to find out how Perkins <br>can extend the life of your engine',


        // Calculation
        'calculation-text-1': 'Injectors last 45% longer when protected by Perkins fuel filters',
        'calculation-text-2': 'Spiral roving & acrylic beading on Ecoplus filters help ensure your fuel filter does its job well',
        'calculation-text-3': 'Ecoplus fuel filters are designed to give your engine maximum protection',
        'calculation-text-4': 'Ecoplus fuel filters have unique features not found on non-genuine filters',
        
        // Results section
        'results': 'Results',
        'results-based-upon': 'Results Based Upon Fuel Filter Testing',
        'customer-saving': 'Customer "Saving" by Buying Non-Genuine Filters',
        'potential-impact': 'Potential Impact of Using Non-Genuine Filters',
        'increased-fuel-costs': 'Increased Fuel Costs',
        'additional-injector-costs': 'Additional Injector Replacement Costs',
        'increase-total-costs': 'Increase to Total Owner & Operation Costs by Fitting Non-Genuine Fuel Filters Over 5 Years',
        'actual-costing-mobile': 'Actual costing using will-fit Filters over Genuine Filters',
        
        // Modal content
        'select-currency': 'Select your currency to continue',
        'continue': 'Continue',
        'assumptions': 'Assumptions',
        'assumptions-us': 'Assumptions (United States)',
        'i-accept': 'I Accept',
        'i-dont-accept': "I don't Accept",
        'select-language': 'Select Language',
        
        // Disclaimer
        'disclaimer': 'This website and the content herein are provided for general informational, display, promotional, conceptual and illustration purposes only and are not intended to form part of any contract or warranty.',
        
        // Alert messages
        'fill-required-fields': 'Please fill in all required fields.',
        'accept-terms-required': 'You must accept the terms to be able to use this tool.',
        'fill-required-fields-confirm': 'OK',
        'accept-terms-required-confirm': 'OK',
        
        // Assumptions text
        'assumptions-text': '<p>This model is a cost risk estimate based on the fuel filter comparison testing completed by Perkins that indicated a fuel injector may last 45% longer using Perkins filters when compared to other good quality will-fit filters available globally, as shown in the Perkins datasheet {{datasheetLink}}.</p><p>The model uses following parameters and assumptions: standard 500 hour service interval, a 3% increase in fuel consumption due to worn fuel injectors, Perkins suggested end user customer pricing for the relevant fuel filters and injectors as fitted to the engine selected, a 30% premium for the price of a genuine Perkins fuel filter above the will-fit version, the number of injectors per engine is based on the configuration of the engine selected, an assumed labour time of between 2 and 5 hours to replace the set of injectors depending on the engine size, a standard 8,000 hour injector replacement period, a standard fuel cost of {{currencySign}}{{fuelCost}} per litre and labour cost of {{currencySign}}{{laborCost}} per hour, and the standard fuel consumption at 50% load for each engine model as shown on the Perkins engine datasheet.</p><p>Currency conversions of GBP price assumptions are updated every 24 hours using GBP to local currency stated on (https://api.exchangeratesapi.io).</p>',
        
        // Mobile picker labels
        'cancel': 'Cancel',
        'confirm': 'Confirm'
    },

    'en-us': {
        // Main form section
        'tell-us-about-engine': 'Tell us about your engine',
        'choose-engine-model': 'Choose Engine Model',
        'engine-running-hours': 'Engine Running Hours p/a',
        'calculate': 'Calculate',
        'calculating': 'Calculating',
        'recalculate': 'Recalculate',
        'connect-with-us': 'Connect with us',
        'distributor-locator': 'Distributor Locator',
        'calculator-assumptions': '*Calculator Assumptions',
        'keep-in-touch': 'Keep in touch',
        'terms-and-conditions': 'Terms and conditions',

        // Form Fields
        'about-you': 'About You',
        'first-name': 'First Name*',
        'surname': 'Surname*',
        'email': 'Email*',
        'select-country': 'Select your Country*',
        'marketing-consent': '* Yes, I would like to receive future marketing communications (such as email) from Perkins, its affiliates and subsidiaries worldwide and the Perkins distributor network. Regardless of whether you decide to receive these marketing communications, Perkins will continue to send service/transactional messages, including those that have to do with any accounts that you may have with us.',
        'submit': 'Submit',
        'distributor-contact': 'Speak to your local distributor to find out how Perkins <br>can extend the life of your engine',

        // Calculation
        'calculation-text-1': 'Injectors last 45% longer when protected by Perkins fuel filters',
        'calculation-text-2': 'Spiral roving & acrylic beading on Ecoplus filters help ensure your fuel filter does its job well',
        'calculation-text-3': 'Ecoplus fuel filters are designed to give your engine maximum protection',
        'calculation-text-4': 'Ecoplus fuel filters have unique features not found on non-genuine filters',

        // Results section
        'results': 'Results',
        'results-based-upon': 'Results Based Upon Fuel Filter Testing',
        'customer-saving': 'Customer "Saving" by Buying Non-Genuine Filters',
        'potential-impact': 'Potential Impact of Using Non-Genuine Filters',
        'increased-fuel-costs': 'Increased Fuel Costs',
        'additional-injector-costs': 'Additional Injector Replacement Costs',
        'increase-total-costs': 'Increase to Total Owner & Operation Costs by Fitting Non-Genuine Fuel Filters Over 5 Years',
        'actual-costing-mobile': 'Actual costing using will-fit Filters over Genuine Filters',

        // Modal content
        'select-currency': 'Select your currency to continue',
        'continue': 'Continue',
        'assumptions': 'Assumptions',
        'assumptions-us': 'Assumptions (United States)',
        'i-accept': 'I Accept',
        'i-dont-accept': "I don't Accept",
        'select-language': 'Select Language',

        // Disclaimer
        'disclaimer': 'This website and the content herein are provided for general informational, display, promotional, conceptual and illustration purposes only and are not intended to form part of any contract or warranty.',

        // Alert messages
        'fill-required-fields': 'Please fill in all required fields.',
        'accept-terms-required': 'You must accept the terms to be able to use this tool.',
        'fill-required-fields-confirm': 'OK',
        'accept-terms-required-confirm': 'OK',

        // Assumptions text
        'assumptions-text': '<p>This model is a cost risk estimate based on the fuel filter comparison testing completed by Perkins that indicated a fuel injector may last 45% longer using Perkins filters when compared to other good quality will-fit filters available globally, as shown in the Perkins datasheet {{datasheetLink}}.</p><p>The model uses following parameters and assumptions: standard 500 hour service interval, a 3% increase in fuel consumption due to worn fuel injectors, Perkins suggested end user customer pricing for the relevant fuel filters and injectors as fitted to the engine selected, a 30% premium for the price of a genuine Perkins fuel filter above the will-fit version, the number of injectors per engine is based on the configuration of the engine selected, an assumed labor time of between 2 and 5 hours to replace the set of injectors depending on the engine size, a standard 8,000 hour injector replacement period, a standard fuel cost of {{currencySign}}{{fuelCost}} per liter and labor cost of {{currencySign}}{{laborCost}} per hour, and the standard fuel consumption at 50% load for each engine model as shown on the Perkins engine datasheet.</p><p>Currency conversions of GBP price assumptions are updated every 24 hours using GBP to local currency stated on (https://api.exchangeratesapi.io).</p>',

        // Mobile picker labels
        'cancel': 'Cancel',
        'confirm': 'Confirm'
    },
    
    es: {
        // Main form section
        'tell-us-about-engine': 'Háblenos de su motor',
        'choose-engine-model': 'Elegir modelo de motor',
        'engine-running-hours': 'Horas de funcionamiento del motor p/a',
        'calculate': 'Calcular',
        'calculating': 'Calculando',
        'recalculate': 'Volver a calcular',
        'connect-with-us': 'Conecte con nosotros',
        'distributor-locator': 'Localizador de distribuidores',
        'calculator-assumptions': '*Supuestos de calculadora',
        'keep-in-touch': 'Mantente en contacto',
        'terms-and-conditions': 'Términos y condiciones',

        // Form Fields
        'about-you': 'Acerca de ti',
        'first-name': 'Nombre*',
        'surname': 'Apellido*',
        'email': 'Email*',
        'select-country': 'Seleccione su pais*',
        'marketing-consent': '* Si, me gustaría recibir futuras comunicaciones de marketing (como correo electrónico) de Perkins, sus filiales y subsidiarias en todo el mundo y la red de distribuidores de Perkins. Independientemente de si decide recibir estas comunicaciones de marketing, Perkins continuará enviando mensajes de servicio/operaciones transaccionales, incluidos aquellos que tengan que ver con cualquier cuenta que pueda tener con nosotros.',
        'submit': 'Enviar',
        'distributor-contact': 'Habla con tu distribuidor local para saber cómo Perkins <br> puede extender la vida de tu motor',
        
        // Calculation
        'calculation-text-1': 'Los inyectores duran un 45 % más cuando están protegidos por filtros de combustible Perkins',
        'calculation-text-2': 'La fibra en espiral y las granallas acrílicas de los filtros Ecoplus ayudan a garantizar que el filtro de combustible funcione correctamente',
        'calculation-text-3': 'Los filtros de combustible Ecoplus están diseñados para proporcionar a su motor la máxima protección',
        'calculation-text-4': 'Los filtros de combustible Ecoplus tienen características únicas que no se encuentran en los filtros no originales',

        // Results section
        'results': 'Resultados',
        'results-based-upon': 'Resultados basados en pruebas de filtros de combustible',
        'customer-saving': 'El cliente "ahorra" al comprar filtros no originales',
        'potential-impact': 'Impacto potencial del uso de filtros no originales',
        'increased-fuel-costs': 'Aumento de los costes de combustible',
        'additional-injector-costs': 'Costes adicionales de sustitución de inyectores',
        'increase-total-costs': 'Aumento de los costes totales de propiedad y funcionamiento por instalar filtros de combustible no originales durante 5 años',
        'actual-costing-mobile': 'Costo real usando filtros compatibles sobre filtros genuinos',
        
        // Modal content
        'select-currency': 'Seleccione su moneda',
        'continue': 'Continuar',
        'assumptions': 'Supuestos',
        'assumptions-us': 'Supuestos (Estados Unidos)',
        'i-accept': 'Acepto',
        'i-dont-accept': 'No Acepto',
        'select-language': 'Seleccione su idioma',
        
        // Disclaimer
        'disclaimer': 'Este sitio web y su contenido se proporcionan únicamente con fines informativos, de exhibición, promocionales, conceptuales e ilustrativos, y no pretenden formar parte de ningún contrato o garantía.',
        
        // Alert messages
        'fill-required-fields': 'Seleccione su modo de motor',
        'accept-terms-required': 'Debe aceptar las condiciones para poder utilizar esta herramienta.',
        'fill-required-fields-confirm': 'Aceptar',
        'accept-terms-required-confirm': 'Aceptar',
        
        // Assumptions text
        'assumptions-text': '<p>Este modelo es una estimación del riesgo de costes basada en las pruebas comparativas de filtros de combustible realizadas por Perkins, que indicaron que un inyector de combustible puede durar un 45 % más utilizando filtros Perkins en comparación con otros filtros de buena calidad disponibles a nivel mundial, tal y como se muestra en la ficha técnica {{datasheetLink}} de Perkins.</p><p>El modelo utiliza los siguientes parámetros y supuestos: intervalo de servicio estándar de 500 horas, un aumento del 3 % en el consumo de combustible debido al desgaste de los inyectores de combustible, el precio de venta al usuario final sugerido por Perkins para los filtros de combustible e inyectores correspondientes instalados en el motor seleccionado, una prima del 30 % sobre el precio de un filtro de combustible Perkins original con respecto a la versión compatible, el número de inyectores por motor se basa en la configuración del motor seleccionado, un tiempo de mano de obra estimado de entre 2 y 5 horas para sustituir el conjunto de inyectores, dependiendo del tamaño del motor, un periodo estándar de sustitución de los inyectores de 8000 horas, un coste estándar del combustible de {{fuelCost}} {{currencySign}} por litro y un coste de mano de obra de {{laborCost}} {{currencySign}} por hora, y el consumo estándar de combustible al 50 % de carga para cada modelo de motor, tal y como se indica en la ficha técnica del motor Perkins.</p><p>Las conversiones monetarias de los precios estimados en libras esterlinas se actualizan cada 24 horas utilizando el tipo de cambio de la libra esterlina a la moneda local que figura en (https://api.exchangeratesapi.io).</p>',
        
        // Mobile picker labels
        'cancel': 'Cancelar',
        'confirm': 'Confirmar'
    },
    
    fr: {
        // Main form section
        'tell-us-about-engine': 'Parlez-nous de votre moteur',
        'choose-engine-model': 'Choisissez le modèle de moteur',
        'engine-running-hours': 'Heures de fonctionnement du moteur p/a',
        'calculate': 'Calculer',
        'calculating': 'Calcul en cours',
        'recalculate': 'Recalculer',
        'connect-with-us': 'Contactez-nous',
        'distributor-locator': 'Localisateur de distributeur',
        'calculator-assumptions': '*Hypothèses du calculateur',
        'keep-in-touch': 'Restez en contact',
        'terms-and-conditions': 'Conditions générales',

        // Calculation
        'calculation-text-1': 'Hausse de la durabilité des injecteurs jusqu’à 45 % lorsqu’ils sont protégés par des filtres à carburant Perkins',
        'calculation-text-2': 'Les filtres Ecoplus sont dotés d’un ruban spiralé et d’un renforcement en acrylique qui contribuent au bon fonctionnement de votre filtre à carburant',
        'calculation-text-3': 'Les filtres à carburant Ecoplus sont conçus pour offrir une protection maximale à votre moteur',
        'calculation-text-4': 'Les filtres à carburant Ecoplus présentent des caractéristiques uniques que ne possèdent pas les filtres non d’origine',
        
        // Form Fields
        'about-you': 'A propos de vous',
        'first-name': 'Prénom*',
        'surname': 'Nom*',
        'email': 'Email*',
        'select-country': 'Sélectionnez votre pays*',
        'marketing-consent': '* Si, je souhaite recevoir des communications marketing futures (comme des emails) de Perkins, ses filiales et filiales en tout le monde et le réseau de distributeurs de Perkins. Indépendamment de si vous décidez de recevoir ces communications marketing, Perkins continuera à envoyer des messages de service/transactions, y compris ceux qui ont trait à n\'importe quel compte que vous pourriez avoir avec nous.',
        'submit': 'Soumettre',
        'distributor-contact': 'Parlez à votre distributeur local pour savoir comment Perkins <br> peut étendre la durée de vie de votre moteur',

        // Results section
        'results': 'Résultats',
        'results-based-upon': 'Résultats s’appuyant sur les tests effectués sur des filtres à carburant',
        'customer-saving': 'L’achat de filtres non d’origine, une « économie » pour le client',
        'potential-impact': 'Impact potentiel de l’utilisation de filtres non d’origine',
        'increased-fuel-costs': 'Réduction des coûts de carburant',
        'additional-injector-costs': 'Coûts supplémentaires inhérents au remplacement de l’injecteur',
        'increase-total-costs': 'Hausse des coûts totaux de propriété et d’exploitation inhérents à l’installation de filtres à carburant non d’origine sur 5 ans',
        'actual-costing-mobile': 'Coût réel utilisant des filtres compatibles par rapport aux filtres genuins',
        
        // Modal content
        'select-currency': 'Sélectionnez votre devise',
        'continue': 'Continuer',
        'assumptions': 'Postulats',
        'assumptions-us': 'Hypothèses (États-Unis)',
        'i-accept': 'J\'accepte',
        'i-dont-accept': 'Je refuse',
        'select-language': 'Sélectionnez votre langue',
        
        // Disclaimer
        'disclaimer': 'Ce site Web et son contenu sont fournis à titre d’informations, de promotion, de conception et d’illustration générales uniquement. Ils ne constituent en aucun cas une partie d’un contrat ou d’une garantie.',
        
        // Alert messages
        'fill-required-fields': 'Veuillez sélectionner le modèle de votre moteur.',
        'accept-terms-required': 'Vous devez accepter les conditions générales pour utiliser cet outil.',
        'fill-required-fields-confirm': 'OK',
        'accept-terms-required-confirm': 'OK',
        
        // Assumptions text
        'assumptions-text': '<p>Ce modèle est une estimation du risque financier qui repose sur les tests comparatifs des filtres à carburant réalisés par Perkins. Ces tests ont montré une augmentation possible de 45 % de la durabilité des injecteurs combinés aux filtres Perkins par rapport à l\'utilisation d\'autres filtres universels de bonne qualité disponibles dans le monde entier, comme indiqué sur la fiche technique {{datasheetLink}} de Perkins.</p><p>Le modèle repose sur les paramètres et hypothèses suivants : intervalle d\'entretien standard de 500 heures, hausse de 3 % de la consommation de carburant inhérente à l\'usure des injecteurs, prix publics des filtres à carburant et des injecteurs adaptés au moteur sélectionné suggérés par Perkins, majoration de 30 % du prix d\'un filtre à carburant Perkins d\'origine par rapport à la version universelle, nombre d\'injecteurs par moteur dépendant de la configuration du moteur sélectionné, temps d\'intervention de la main-d\'œuvre estimé entre 2 et 5 heures pour remplacer l\'ensemble d\'injecteurs en fonction de la taille du moteur, période de remplacement standard des injecteurs de 8 000 heures, coût standard du carburant de {{fuelCost}} {{currencySign}} par litre et coût de main-d\'œuvre de {{laborCost}} {{currencySign}} par heure, et consommation de carburant standard à 50 % de charge pour chaque modèle de moteur, comme indiqué sur la fiche technique du moteur Perkins.</p><p>Les conversions monétaires des hypothèses de prix en GBP sont mises à jour toutes les 24 heures à l\'aide du taux de change entre la livre sterling et la devise locale disponible sur (https://api.exchangeratesapi.io).</p>',
        
        // Mobile picker labels
        'cancel': 'Annuler',
        'confirm': 'Confirmer'
    },
    
    de: {
        // Main form section
        'tell-us-about-engine': 'Teilen Sie uns bitte mehr über Ihren Motor mit',
        'choose-engine-model': 'Motormodell auswählen',
        'engine-running-hours': 'Motorbetriebsstunden pro Jahr',
        'calculate': 'Berechnen',
        'calculating': 'Die Berechnung wird durchgeführt',
        'recalculate': 'Neu berechnen',
        'connect-with-us': 'Setzen Sie sich mit uns in Verbindung',
        'distributor-locator': 'Händlersuche',
        'calculator-assumptions': '* Annahmen für die Berechnung',
        'keep-in-touch': 'Kontakt aufnehmen',
        'terms-and-conditions': 'Allgemeine Geschäftsbedingungen',

        // Calculation
        'calculation-text-1': 'Einspritzdüsen halten 45 % länger, wenn sie durch Perkins-Kraftstofffilter geschützt werden',
        'calculation-text-2': 'Die Spiralfaserstränge und Akrylnähte von Ecoplus-Filtern sorgen dafür, dass Ihr Kraftstofffilter gut funktioniert',
        'calculation-text-3': 'Ecoplus-Kraftstofffilter sind für den bestmöglichen Schutz Ihres Motors ausgelegt',
        'calculation-text-4': 'Ecoplus-Kraftstofffilter verfügen über einzigartige Eigenschaften, die Nichtoriginalfilter nicht aufweisen',
        
        // Form Fields
        'about-you': 'Über Sie',
        'first-name': 'Vorname*',
        'surname': 'Nachname*',
        'email': 'Email*',
        'select-country': 'Wählen Sie Ihr Land*',
        'marketing-consent': '* Wenn Sie möchten, dass Sie von Perkins, seinen Filialen und Filialen weltweit und der Perkins-Distributor-Netzwerk Nachrichten erhalten (z. B. E-Mails), Perkins wird weiterhin Nachrichten senden, die mit der Wartung/Transaktionen verbunden sind, einschließlich derjenigen, die mit Ihrem Konto mit uns verbinden.',
        'submit': 'Senden',
        'distributor-contact': 'Sprich mit deinem lokalen Distributor, um zu erfahren, wie Perkins <br> die Lebensdauer Ihres Motors verlängern kann',

        // Results section
        'results': 'Ergebnisse',
        'results-based-upon': 'Ergebnisse auf der Grundlage von Kraftstofffiltertests',
        'customer-saving': '"Einsparungen" für den Kunden durch den Kauf von Nichtoriginalfiltern',
        'potential-impact': 'Potenzielle Auswirkungen bei der Verwendung von Nichtoriginalfiltern',
        'increased-fuel-costs': 'Erhöhte Kraftstoffkosten',
        'additional-injector-costs': 'Kosten für den zusätzlichen Einspritzdüsentausch',
        'increase-total-costs': 'Erhöhung der gesamten Vorhalte- und Betriebskosten durch den Einbau von nichtoriginalen Kraftstofffiltern über 5 Jahre',
        'actual-costing-mobile': 'Tatsächliche Kosten mit kompatiblen Filtern gegenüber Original-Filtern',
        
        // Modal content
        'select-currency': 'Währung auswählen',
        'continue': 'Fortfahren',
        'assumptions': 'Annahmen',
        'assumptions-us': 'Annahmen (Vereinigte Staaten)',
        'i-accept': 'Ich stimme zu',
        'i-dont-accept': 'Ich stimme nicht zu',
        'select-language': 'Sprache auswählen',
        
        // Disclaimer
        'disclaimer': 'Diese Website und ihr Inhalt dienen nur zur allgemeinen Information, zur Veranschaulichung, zu Werbezwecken sowie zu Zwecken der Konzeptvorstellung und Illustration und sind nicht als Teil eines Vertrags oder einer Garantie zu verstehen.',
        
        // Alert messages
        'fill-required-fields': 'Bitte wählen Sie Ihr Motormodell aus.',
        'accept-terms-required': 'Um dieses Tool verwenden zu können, müssen Sie den Bedingungen zustimmen.',
        'fill-required-fields-confirm': 'OK',
        'accept-terms-required-confirm': 'OK',
        
        // Assumptions text
        'assumptions-text': '<p>Bei diesem Modell handelt es sich um eine Kosten-Risiko-Einschätzung, die auf den von Perkins durchgeführten Kraftstofffiltervergleichstests beruht, die darauf hindeuten, dass eine Einspritzdüse mit Perkins-Filtern 45 % länger hält als mit weltweit verfügbaren hochwertigen generischen Filtern (siehe Perkins-Datenblatt {{datasheetLink}}).</p><p>Das Modell beruht auf den folgenden Parametern und Annahmen: ein Standardserviceintervall von 500 Stunden, eine 3%ige Erhöhung des Kraftstoffverbrauchs durch verschlissene Einspritzdüsen, von Perkins empfohlene Endverbraucherpreise für die jeweiligen im ausgewählten Motor eingebauten Kraftstofffilter and Einspritzdüsen, ein 30 % höherer Preis von echten Perkins-Kraftstofffiltern im Vergleich zur generischen Version, die bei der ausgewählten Motorkonfiguration zum Einsatz kommende Anzahl von Einspritzdüsen, eine geschätzte Arbeitszeit von 2 bis 5 Stunden (je nach Motorgröße) zum Tausch des Einspritzdüsensatzes, ein Standardaustauschintervall für die Einspritzdüsen von 8000 Betriebsstunden, Standardkraftstoffkosten von {{fuelCost}} {{currencySign}} pro Liter und Arbeitskosten von {{laborCost}} {{currencySign}} pro Stunde sowie der Standardkraftstoffverbrauch unter einer Last von 50 % für die jeweiligen Motormodelle gemäß dem jeweiligen Perkins-Motordatenblatt.</p><p>Die Währungsumrechnung für die angesetzten GBP-Preise in die örtliche Währung wird alle 24 Stunden aktualisiert (https://api.exchangeratesapi.io).</p>',
        
        // Mobile picker labels
        'cancel': 'Abbrechen',
        'confirm': 'Bestätigen'
    },

    pt: {
        // Main form section
        'tell-us-about-engine': 'Fale-nos do motor',
        'choose-engine-model': 'Escolher modelo do motor',
        'engine-running-hours': 'Horas do motor em funcionamento p/a',
        'calculate': 'Calcular',
        'calculating': 'A calcular',
        'recalculate': 'Recalcular',
        'connect-with-us': 'Entre em contacto connosco',
        'distributor-locator': 'Localizador de distribuidores',
        'calculator-assumptions': '*Pressupostos da calculadora',
        'keep-in-touch': 'Manter contato',
        'terms-and-conditions': 'Termos e condições',
        
        // Calculation
        'calculation-text-1': 'Os injetores duram 45% mais tempo com a proteção dos filtros do combustível Perkins',
        'calculation-text-2': 'A mecha em espiral e esferas em acrílico dos filtros Ecoplus ajudam a garantir um bom desempenho do filtro do combustível',
        'calculation-text-3': 'Os filtros do combustível Ecoplus foram concebido para oferecer máxima proteção para o seu motor',
        'calculation-text-4': 'Os filtros do combustível Ecoplus contam com características únicas que não estão presentes nos filtros não genuínos',
        
        // Form Fields
        'about-you': 'Sobre você',
        'first-name': 'Primeiro nome*',
        'surname': 'Sobrenome*',
        'email': 'Email*',
        'select-country': 'Seleccione seu pais*',
        'marketing-consent': '* Sim, gostaria de receber futuras comunicações de marketing (como e-mail) de Perkins, suas filiais e subsidiárias em todo o mundo e a rede de distribuidores de Perkins. Independentemente de você decidir receber estas comunicações de marketing, Perkins continuará enviando mensagens de serviço/operações transacionais, incluindo aqueles que tenham relação com sua conta com nós.',
        'submit': 'enviar',
        'distributor-contact': 'Fale com seu distribuidor local para saber como Perkins <br> pode estender a vida do seu motor',

        // Results section
        'results': 'Resultados',
        'results-based-upon': 'Resultados com base em testes aos filtros do combustível',
        'customer-saving': '"Poupança" para o cliente ao comprar filtros não genuínos',
        'potential-impact': 'Potencial impacto de utilizar filtros não genuínos',
        'increased-fuel-costs': 'Aumento dos custos do combustível',
        'additional-injector-costs': 'Custos extra com a troca dos injetores',
        'increase-total-costs': 'Aumento dos custos totais operacionais e de propriedade ao instalar filtros do combustível não genuínos num período de 5 anos',
        'actual-costing-mobile': 'Custo real usando filtros compatíveis em vez de filtros genuínos',
        
        // Modal content
        'select-currency': 'Selecione a moeda',
        'continue': 'Continuar',
        'assumptions': 'Pressupostos',
        'assumptions-us': 'Pressupostos (Estados Unidos)',
        'i-accept': 'Aceito',
        'i-dont-accept': 'Não aceito',
        'select-language': 'Selecione o idioma',
        
        // Disclaimer
        'disclaimer': 'Este website e o conteúdo aqui presente são fornecidos apenas para fins informativos, promocionais, concetuais, ilustrativos e de apresentação e se não se destinam a formar parte de contratos ou garantias.',
        
        // Alert messages
        'fill-required-fields': 'Selecione o modelo do motor.',
        'accept-terms-required': 'Tem de aceitar os termos para utilizar esta ferramenta.',
        'fill-required-fields-confirm': 'OK',
        'accept-terms-required-confirm': 'OK',
        
        // Assumptions text
        'assumptions-text': '<p>Este modelo é uma estimativa de custos-riscos com base nos testes comparativos de filtros do combustível realizados pela Perkins, os quais indicaram que um injetor de combustível poderá durar 45% mais tempo com filtros Perkins, por comparação com outros filtros de boa qualidade da concorrência, tal como demonstrado na ficha de dados Perkins {{datasheetLink}}.</p><p>O modelo utiliza os seguintes parâmetros e pressupostos: intervalo de serviço padrão de 500 horas; aumento de 3% do consumo de combustível devido ao desgaste dos injetores de combustível; preço para o utilizador final sugerido pela Perkins para os filtros do combustível e injetores em questão e conforme instalados no motor selecionado; margem premium de 30% pelo preço de um filtro do combustível Perkins genuíno acima da versão da concorrência; o número de injetores por motor depende da configuração do motor selecionada; pressuposição de mão de obra de 2 a 5 horas para trocar o conjunto de injetores, conforme o tamanho do motor; período de troca dos injetores padrão de 8000 horas; custo padrão do combustível de {{fuelCost}} {{currencySign}} por litro e custo de mão de obra de {{laborCost}} {{currencySign}} por hora; e consumo de combustível padrão a 50% de carga para cada modelo de motor, conforme apresentado na ficha de dados do motor Perkins.</p><p>As conversões dos pressupostos de preços em GBP são atualizadas a cada 24 horas, utilizando a taxa de câmbio de GBP para a moeda local em https://api.exchangeratesapi.io.</p>'
    },

    zh: {
        // Main form section
        'tell-us-about-engine': '请提供您的发动机相关信息',
        'choose-engine-model': '选择发动机型号',
        'engine-running-hours': '运行小时 每年',
        'calculate': '计算',
        'calculating': '计算',
        'recalculate': '重新计算',
        'connect-with-us': '与我们联系',
        'distributor-locator': '经销商定位器',
        'calculator-assumptions': '计算前提条件',
        'keep-in-touch': '保持联系',
        'terms-and-conditions': '条款和条件',
        
        // Calculation
        'calculation-text-1': '在受到 Perkins 燃油滤清器保护的情况下，喷油器的寿命能延长 45%',
        'calculation-text-2': 'Ecoplus 滤清器上的螺旋式粗纱和丙烯酸串珠有助于确保您的燃油滤清器正常工作',
        'calculation-text-3': 'Ecoplus 燃油滤清器旨在为您的发动机提供最大程度的保护',
        'calculation-text-4': 'Ecoplus 燃油滤清器具备非原装滤清器所不具备的独特特性',

        // Form Fields
        'about-you': '关于您',
        'first-name': '名字*',
        'surname': '姓*',
        'email': '电子邮件*',
        'select-country': '选择您的国家*',
        'marketing-consent': '* 是的，我愿意接收 Perkins、其子公司和分销商的营销通讯（如电子邮件）。即使您选择不接收营销通讯， Perkins 仍将发送与您的账户相关的服务/运营交易消息，包括任何与您的账户相关的消息。',
        'submit': '提交',
        'distributor-contact': '与您的本地分销商联系以了解 Perkins <br> 如何延长您的发动机寿命',

        // Results section
        'results': '结果',
        'results-based-upon': '结果基于燃油滤清器测试',
        'customer-saving': '客户购买非原厂滤清器实现的“省钱”',
        'potential-impact': '使用非原厂滤清器的潜在影响',
        'increased-fuel-costs': '燃油成本增加',
        'additional-injector-costs': '额外的喷油器更换成本',
        'increase-total-costs': '5 年内使用非原装燃油滤清器导致的总拥有及运营成本增加',
        'actual-costing-mobile': '使用通用滤清器与原装滤清器的实际成本',
        
        // Modal content
        'select-currency': '选择您的货币',
        'continue': '继续',
        'assumptions': '前提条件',
        'assumptions-us': '前提条件（美国）',
        'i-accept': '我接受',
        'i-dont-accept': '我不接受',
        'select-language': '选择您的语言',
        
        // Disclaimer
        'disclaimer': '本网站及其内容仅供一般参考、展示、宣传、概念说明及示意之用，不构成任何合同或保修的内容。',
        
        // Alert messages
        'fill-required-fields': '请选择您的发动机型号。',
        'accept-terms-required': '您必须接受条款才能使用此工具。',
        'fill-required-fields-confirm': '确定',
        'accept-terms-required-confirm': '确定',
        
        // Assumptions text
        'assumptions-text': '<p>该模型基于 Perkins 完成的燃油滤清器对比测试结果，对成本风险进行估算。测试表明，使用 Perkins 滤清器时，喷油器的使用寿命可比使用全球市场上其他优质通用型滤清器延长 45%，具体数据详见 Perkins 数据表 {{datasheetLink}}。</p><p>该模型采用以下参数和前提条件：标准 500 小时维修周期，因喷油器磨损导致燃油消耗增加 3%，Perkins 建议最终用户价格（适用于所选发动机配套的燃油滤清器和喷油器），Perkins 原厂燃油滤清器价格较通用型高出 30%，每台发动机喷油器数量基于所选发动机配置，更换整套喷油器所需工时（根据发动机排量）假设为 2 至 5 小时，标准喷油器更换周期为 8000 小时，标准燃油成本为每升 {{fuelCost}} 英镑，人工成本为每小时 {{laborCost}} 英镑，各发动机型号在 50% 负载下的标准燃油消耗量参照 Perkins 发动机数据表所示。</p><p>英镑价格前提条件的货币转换每 24 小时更新一次，采用的是（https://api.exchangeratesapi.io）网站上公布的英镑与当地货币的汇率。</p>',
        // Mobile picker labels
        'cancel': '取消',
        'confirm': '确认'
    }
};

// Language configuration
export const languageConfig = {
    defaultLanguage: 'en',
    supportedLanguages: ['en', 'en-us', 'es', 'fr', 'de', 'pt', 'zh'],
    languageNames: {
        en: 'English',
        'en-us': 'English (US)',
        es: 'Español', 
        fr: 'Français',
        de: 'Deutsch',
        pt: 'Português',
        zh: '中文'
    },
    languageFlags: {
        en: '🇬🇧',
        'en-us': '🇺🇸',
        es: '🇪🇸',
        fr: '🇫🇷', 
        de: '🇩🇪',
        pt: '🇵🇹',
        zh: '🇨🇳'
    }
};

// Translation utility class
export class LanguageManager {
    constructor() {
        this.currentLanguage = this.getStoredLanguage() || languageConfig.defaultLanguage;
        this.translations = translations;
    }

    // Get stored language from localStorage
    getStoredLanguage() {
        try {
            return localStorage.getItem('perkins-calculator-language');
        } catch (e) {
            return null;
        }
    }

    // Set and store language
    setLanguage(languageCode) {
        if (languageConfig.supportedLanguages.includes(languageCode)) {
            this.currentLanguage = languageCode;
            try {
                localStorage.setItem('perkins-calculator-language', languageCode);
            } catch (e) {
                console.warn('Could not save language preference to localStorage');
            }
            this.updatePageTranslations();
            return true;
        }
        return false;
    }

    // Get translation for a key
    translate(key) {
        const translation = this.translations[this.currentLanguage]?.[key];
        return translation || this.translations[languageConfig.defaultLanguage]?.[key] || key;
    }

    applyTemplate(translation, element) {
        // Skip template work when there's nothing to replace or no DOM context.
        if (!translation || !element || !translation.includes('{{')) {
            return translation;
        }

        // Pull live values from the DOM; fall back to sensible defaults for initial render.
        const currencySign = element.querySelector('.currency-sign')?.textContent?.trim() || '£';
        const fuelCost = element.querySelector('.fuelcost')?.textContent?.trim() || '1.56';
        const laborCost = element.querySelector('.cost')?.textContent?.trim() || '60';
        // Keep the existing link if present, otherwise inject the default datasheet anchor.
        const datasheetLink = element.querySelector('.datasheet-link')?.outerHTML
            || '<a target="_blank" href="https://s7d2.scene7.com/is/content/Caterpillar/CM20240731-31c00-8c6a5?_gl=1*13g7bx3*_gcl_au*MTk5NDQ3NzQ5Ny4xNzI5MTY1OTM4*_ga*MTE0NDgxODA4NC4xNjkzMzA2NzQ3*_ga_RX13XMZKNR*MTczNjQxODQwNi40MS4xLjE3MzY0MTg0ODQuNTYuMC4wse">PP3111EN-02</a>';
        const replacements = {
            currencySign: `<span class="currency-sign">${currencySign}</span>`,
            fuelCost: `<span class="fuelcost">${fuelCost}</span>`,
            laborCost: `<span class="cost">${laborCost}</span>`,
            datasheetLink
        };

        // Replace only the supported tokens and leave unknown tokens untouched.
        return translation.replace(/{{\s*(currencySign|fuelCost|laborCost|datasheetLink)\s*}}/g, (match, key) => {
            return replacements[key] || match;
        });
    }

    // Update all translations on the page
    updatePageTranslations() {
        // Update elements with data-translate attribute
        document.querySelectorAll('[data-translate]').forEach(element => {
            const key = element.getAttribute('data-translate');
            const translation = this.translate(key);
            
            if (element.tagName === 'INPUT' && (element.type === 'button' || element.type === 'submit')) {
                element.value = translation;
            } else if (element.tagName === 'INPUT' && element.placeholder !== undefined) {
                element.placeholder = translation;
            } else {
                element.innerHTML = this.applyTemplate(translation, element);
            }
        });

        // Update select options with data-translate
        document.querySelectorAll('option[data-translate]').forEach(option => {
            const key = option.getAttribute('data-translate');
            option.textContent = this.translate(key);
        });

        // Update button text content
        document.querySelectorAll('button[data-translate]').forEach(button => {
            const key = button.getAttribute('data-translate');
            button.textContent = this.translate(key);
        });

        // Trigger custom event for other components that need to update
        document.dispatchEvent(new CustomEvent('languageChanged', {
            detail: { language: this.currentLanguage }
        }));
    }

    // Get current language
    getCurrentLanguage() {
        return this.currentLanguage;
    }

    // Get available languages
    getAvailableLanguages() {
        return languageConfig.supportedLanguages.map(code => ({
            code,
            name: languageConfig.languageNames[code],
            flag: languageConfig.languageFlags[code]
        }));
    }
}

// Global instance
export const languageManager = new LanguageManager();
